import { Typography } from '@gurupay/gp-ui-library';
import { useTranslation } from 'react-i18next';

import { FAQ, PRICELIST_EN, PRICELIST_LT } from './constants';

interface AdditionalLinksProps {
	isFaqNeeded?: boolean;
	isPricelistNeeded?: boolean;
}
const AdditionalInfoLinks = ({
	isFaqNeeded,
	isPricelistNeeded,
}: AdditionalLinksProps) => {
	const { t, i18n } = useTranslation('', { keyPrefix: 'messages' });
	const isENLang = i18n.language === 'en';

	return (
		<>
			{isFaqNeeded && (
				<Typography className="mb-space-16">
					{t('infoText')}
					<a
						href={FAQ}
						className="text-brand-secondary-600 hover:border-b hover:text-neutral-950 transition-all duration-300"
						rel="noreferrer"
						target="_blank"
					>
						{t('faqPage')}
					</a>
				</Typography>
			)}
			{isPricelistNeeded && (
				<Typography className="mb-space-16">
					{t('infoText')}
					<a
						href={isENLang ? PRICELIST_EN : PRICELIST_LT}
						className="text-brand-secondary-600 hover:border-b hover:text-neutral-950 transition-all duration-300"
						rel="noreferrer"
						target="_blank"
					>
						{t('pricelist')}
					</a>
				</Typography>
			)}
		</>
	);
};

export default AdditionalInfoLinks;
